
function Footer()
{
    return (
        <footer className="footerMain">
            <p> Divyam Sharma </p>
        </footer>
    )
}

export default Footer